module.exports = __webpack_public_path__ + "img/sheji.6caeb872.png";